import RequestService from "./RequestService";

const ReportService = {
    sendReport: function (params) {
        return RequestService.post(`/report/send`, params);
    },
}

export default ReportService;